import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../integrations/supabase/client'
import { User, LogIn, LogOut, UserCircle } from 'lucide-react'

export default function UserMenu() {
  const [user, setUser] = useState<any>(null)
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
    })
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
    })
    return () => subscription.unsubscribe()
  }, [])

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const handleLogout = async () => {
    await supabase.auth.signOut()
    setOpen(false)
    navigate('/')
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        className="btn-info"
        onClick={() => {
          if (!user) { navigate('/auth'); return }
          setOpen(o => !o)
        }}
        title={user ? 'Profilo' : 'Accedi'}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        {user ? <UserCircle size={20} /> : <User size={18} />}
      </button>

      {open && user && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: 6,
          background: 'var(--bg-2)',
          border: '1px solid var(--border-md)',
          borderRadius: 10,
          padding: 6,
          minWidth: 180,
          boxShadow: '0 8px 30px rgba(0,0,0,0.3)',
          zIndex: 1000,
        }}>
          <div style={{ padding: '8px 12px', fontSize: 11, color: 'var(--text-3)', borderBottom: '1px solid var(--border)', marginBottom: 4 }}>
            {user.email}
          </div>
          <button
            onClick={() => { setOpen(false); navigate('/profilo') }}
            style={menuItemStyle}
          >
            <UserCircle size={14} /> Il mio profilo
          </button>
          <button
            onClick={handleLogout}
            style={{ ...menuItemStyle, color: '#ef4444' }}
          >
            <LogOut size={14} /> Esci
          </button>
        </div>
      )}
    </div>
  )
}

const menuItemStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  width: '100%',
  background: 'none',
  border: 'none',
  padding: '8px 12px',
  fontSize: 13,
  color: 'var(--text-1)',
  cursor: 'pointer',
  borderRadius: 6,
  textAlign: 'left',
  fontFamily: 'var(--font-body)',
}
